import * as React from 'react';
import 'react-perfect-scrollbar/dist/css/styles.css';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { NavHashLink } from 'react-router-hash-link';
import logo from '../assets/img/logo_mutesoyo.svg';

export default function Sidebar1Depth({ activeSection, isMobile, onDrawerToggle }) { 

  const getNavPath = (id) => {
    // 모바일이면 '/id', PC면 '/#id' 반환
    return isMobile ? `/${id}` : `/#${id}`;
  };

  const handleLinkClick = () => {
    // 모바일에서 메뉴 클릭 시 사이드바가 닫히도록 설정 (필요 시)
    if (isMobile && onDrawerToggle) {
      onDrawerToggle();
    }
  };

  // PC 모드 전용 스크롤 이동 함수
  const scrollWithOffset = (el) => {
    // 현재 스크롤이 발생하고 있는 main 컨테이너를 찾습니다.
    const container = document.querySelector('.container');

    if (container && el) {
      // 컨테이너 상단으로부터 엘리먼트까지의 거리 계산
      const elementPosition = el.offsetTop;
      const headerOffset = 20; // 필요에 따라 여백 조절

      container.scrollTo({
        top: elementPosition - headerOffset,
        behavior: 'smooth'
      });
    }
  };

  return (  
    <div className={`sidebar-wrap ${isMobile ? 'mobile' : ''}`} variant="permanent">
      <PerfectScrollbar>
        {/* Menu Levels Sample */}
        <section className='sidebar'>
          <p className='brand-title'> 
            <strong>“뮤트소요, 고요함 속의 산책”</strong>
            <span>Photo Studio & Cafe</span>
          </p>
          <ul className='menu'>
            {['gallery', 'product', 'about', 'reservation', 'qna'].map((id) => (
              <li className='menu-levels' key={id}>
                <NavHashLink 
                  smooth 
                  to={getNavPath(id)}
                  onClick={handleLinkClick}
                  scroll={el => !isMobile && scrollWithOffset(el)}
                  className={`menu-levels-1 ${activeSection === id ? 'activated' : ''}`}
                >
                  <span className='txt'>{id.toLowerCase()}</span>
                </NavHashLink>
              </li>
            ))}
          </ul>
        </section>
      </PerfectScrollbar>
    </div>      
  );
}